<ng-container [ngSwitch]="dialogType">
  <div class="modal-container" *ngSwitchCase="'project_detail_dialog'">
    <div id="step4" class="content">
      <p
        class="status-badge"
        [ngClass]="{
          'under-preparation': data.status === 'Preparation',
          execution: data.status === 'Execution',
          closed: data.status === 'Closed',
        }"
      >
        {{ ('KNOWLEDGE.HEADER_GENERAL.STATUS_' + (data.status || '').toUpperCase()) | translate }}
      </p>

      <h3 class="title-medium bold">{{ data.projectNumber }}</h3>
      <p class="body-medium description">{{ data.title | changeLanguage }}</p>
      <div class="icons mt-1">
        @if (data.year | isValidYear) {
          <div>
            <mat-icon fontIcon="calendar_month" class="icon-s outline"></mat-icon>
            <span class="idb-label-large-semi-bold">{{ data.year }}</span>
          </div>
        }
        <div>
          <mat-icon fontIcon="folder" class="icon-s outline"></mat-icon>
          <span class="idb-label-large-semi-bold">{{ data.responsibilityUnit }}</span>
        </div>
      </div>
      <div class="buttons-modals">
        @if (data.isRemoteProject) {
          <div class="buttons-container project-detail-button mt-1">
            <a
              id="button_project_detail_dialog"
              data-fs-element="Home-Project-Card-Button-Project-Detail"
              (click)="navigateToRemoteProjectDetail(data)"
              class="secondary-button project-detail label-large-semibold"
            >
              <mat-icon fontSet="material-symbols-outlined" class="icon-m outline">
                auto_awesome_mosaic
              </mat-icon>
              {{ 'HOMEMODALS.PROJECTDETAILBUTTON' | translate }}
            </a>
          </div>
          <mat-divider class="color-divider"></mat-divider>
        }
        @if (data.status === 'Execution' && !data.isRemoteProject) {
          <div class="buttons-container btn-execution mt-1">
            <a
              id="button_created_lesson_dialog"
              data-fs-element="Home-Project-Card-Button-Create-Lesson"
              (click)="navigateToLessonsSelectSet(data)"
              class="secondary-button label-large semi-bold w-100 flex-justify-center"
            >
              <mat-icon fontIcon="edit" class="icon-m outline"></mat-icon>
              {{ 'HOMEMODALS.CREATELESSONBUTTON' | translate }}
            </a>
          </div>
          <mat-divider class="color-divider"></mat-divider>
        }
        <div id="step_buckets" class="buttons-container">
          <a
            id="button_similar_dialog"
            data-fs-element="Home-Project-Card-Button-Similar-Projects"
            class="secondary-button similar-projects label-large semi-bold"
            (click)="navigateToKnowledgePills(data, PillType.SimilarProjects)"
          >
            <mat-icon fontIcon="widgets" class="icon-m outline"></mat-icon>
            {{ 'HOMEMODALS.SIMILARBUTTON' | translate }}
          </a>

          <a
            id="button_lesson_dialog"
            data-fs-element="Home-Project-Card-Button-Lessons-Learned"
            class="secondary-button lessons-learned label-large semi-bold"
            (click)="navigateToKnowledgePills(data, PillType.LessonsLearned)"
          >
            <mat-icon fontIcon="folder_special" class="icon-m outline"></mat-icon>
            {{ 'HOMEMODALS.LESSONSLEARNEDBUTTON' | translate }}
          </a>
          <a
            id="button_data_dialog"
            data-fs-element="Home-Project-Card-Button-Data"
            class="secondary-button data-button label-large semi-bold"
            (click)="navigateToKnowledgePills(data, PillType.Data)"
          >
            <span class="icon-idb icon-idb-bubble_chart"></span>
            {{ 'HOMEMODALS.DATABUTTON' | translate }}
          </a>

          <a
            id="button_literature_dialog"
            data-fs-element="Home-Project-Card-Button-Literature"
            class="secondary-button literature-button label-large semi-bold"
            (click)="navigateToKnowledgePills(data, PillType.Literature)"
          >
            <mat-icon fontIcon="menu_book" class="icon-m outline"></mat-icon>
            {{ 'HOMEMODALS.LITERATUREBUTTON' | translate }}
          </a>

          <a
            id="button_document_dialog"
            data-fs-element="Home-Project-Card-Button-Institutional-Documents"
            class="secondary-button institutional-documents label-large semi-bold"
            (click)="navigateToKnowledgePills(data, PillType.InstitutionalDocuments)"
          >
            <mat-icon fontIcon="account_balance" class="icon-m outline"></mat-icon>
            {{ 'HOMEMODALS.INSTITUTIONALBUTTON' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-container flex-column" *ngSwitchCase="'confirm_dialog'">
    <div class="header">
      <mat-icon>info</mat-icon>
      <h3 class="h3-headline-small-semi-bold">
        {{ (data.title ?? '') | translate }}
      </h3>
    </div>
    <div class="text-container body-large">
      <p [innerHTML]="(data.message ?? '') | translate: data.messageParams"></p>
    </div>
    <div class="footer-container">
      <button
        [attr.data-fs-element]="data.whiteButtonFsElement || 'Dialog-Button-White'"
        mat-button
        (click)="confirmDialog(true)"
      >
        {{ (data.whiteButton ?? '') | translate }}
      </button>
      <button
        [attr.data-fs-element]="data.blueButtonFsElement || 'Dialog-Button-Blue'"
        mat-button
        class="btn-primary"
        *ngIf="data.blueButton"
        (click)="confirmDialog(false)"
      >
        {{ data.blueButton | translate }}
      </button>
    </div>
  </div>
</ng-container>
